const saveAndBackButtonsSection = {
	back: 'Wstecz',
	save: 'Zapisz zmiany'
};

export default saveAndBackButtonsSection;